/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.ai.editor.rpc.LayoutGeneration
 */

export const AssistantFeatureComponentTypename = 'com.hubspot.breeze.quality.experiments.components.AssistantFeatureComponent';
export const ChirpToolComponentTypename = 'com.hubspot.breeze.quality.experiments.components.ChirpToolComponent';
export const SystemPromptComponentTypename = 'com.hubspot.breeze.quality.experiments.components.SystemPromptComponent';
export const AskAcademyRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskAcademyRequest';
export const AskInAppHelpRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskInAppHelpRequest';
export const CompanyCompetitorsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyCompetitorsRequest';
export const CompanyFundingRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyFundingRequest';
export const CompanyLookupRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyLookupRequest';
export const CompanyTechRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyTechRequest';
export const ContentRewriteRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ContentRewriteRequest';
export const CopilotCapabilitiesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CopilotCapabilitiesRequest';
export const CreateBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateBlogPostRequest';
export const CreateNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateNewsSubscriptionRequest';
export const CustomSystemPromptRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CustomSystemPromptRequest';
export const DeleteNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DeleteNewsSubscriptionRequest';
export const DiscoverCompaniesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DiscoverCompaniesRequest';
export const DraftBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftBlogPostRequest';
export const DraftSalesEmailRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailRequest';
export const DraftSalesEmailTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailTemplateRequest';
export const ImageGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ImageGenerateRequest';
export const ListNewsSubscriptionsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNewsSubscriptionsRequest';
export const ListNotesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNotesRequest';
export const NewsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NewsRequest';
export const NoteCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateRequest';
export const NoteCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateTemplateRequest';
export const ObjectAddRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAddRequest';
export const ObjectAssignRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssignRequest';
export const ObjectAssociationsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssociationsRequest';
export const ObjectCountRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectCountRequest';
export const ObjectListRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectListRequest';
export const ObjectSummaryRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectSummaryRequest';
export const ObjectUpdateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectUpdateRequest';
export const OrchestrationPlanExecutionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanExecutionRequest';
export const OrchestrationPlanningRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanningRequest';
export const ReportBuilderRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ReportBuilderRequest';
export const SummarizeArticleRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.SummarizeArticleRequest';
export const TaskCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateRequest';
export const TaskCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateTemplateRequest';
export const TextGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TextGenerateRequest';
export const ActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButton';
export const ActionButtonV2Typename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButtonV2';
export const BreezeActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.BreezeActionButton';
export const LinkButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.LinkButton';
export const TemplateButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.TemplateButton';
export const AccordionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AccordionResponseSection';
export const ActionsResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ActionsResponseSection';
export const AvatarCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AvatarCardResponseSection';
export const BarChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.BarChartResponseSection';
export const CardWrapperResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CardWrapperResponseSection';
export const ChipsCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ChipsCardResponseSection';
export const CollaborationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CollaborationResponseSection';
export const CompanyOverviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CompanyOverviewResponseSection';
export const ConfirmationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ConfirmationResponseSection';
export const CrmCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CrmCardResponseSection';
export const DashboardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DashboardResponseSection';
export const DataTableResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSection';
export const DataTableResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSectionV2';
export const DenseListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DenseListResponseSection';
export const DraftEmailResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DraftEmailResponseSection';
export const ErrorResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ErrorResponseSection';
export const FilterBranchResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.FilterBranchResponseSection';
export const GridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.GridResponseSection';
export const HtmlCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlCardResponseSection';
export const HtmlTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlTextResponseSection';
export const HtmlWithChildrenResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlWithChildrenResponseSection';
export const InlineCitationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.InlineCitationResponseSection';
export const LlmResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection';
export const MetricCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.MetricCardResponseSection';
export const NewsListCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.NewsListCardResponseSection';
export const PlainTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.PlainTextResponseSection';
export const ReportResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ReportResponseSection';
export const SourcesListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.SourcesListResponseSection';
export const TabResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TabResponseSection';
export const TemplateResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TemplateResponseSection';
export const ThoughtResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ThoughtResponseSection';
export const TimelineCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TimelineCardResponseSection';
export const UnstyledImageResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UnstyledImageResponseSection';
export const UserActionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserActionResponseSection';
export const UserChatResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserChatResponseSection';
export const VisualizationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.VisualizationResponseSection';
export const CardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CardResponseSection';
export const CompanyCardTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CompanyCard';
export const DoubleCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.DoubleCardFieldValue';
export const IntegerCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.IntegerCardFieldValue';
export const LinkCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.LinkCardFieldValue';
export const StringCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.StringCardFieldValue';
export let ComHubspotChatspotMessageSchemasSectionsCitation;
(function (_ComHubspotChatspotMessageSchemasSectionsCitation) {})(ComHubspotChatspotMessageSchemasSectionsCitation || (ComHubspotChatspotMessageSchemasSectionsCitation = {}));
export const ContextItemResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.contextitem.ContextItemResponseSection';
export const FileAttachmentResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.file.FileAttachmentResponseSection';
export const ImageGridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.image.ImageGridResponseSection';
export const MediaPreviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSection';
export const MediaPreviewResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSectionV2';
export const MeetingResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingResponseSection';
export const BrandVoiceFieldTypename = 'com.hubspot.chatspot.message.schemas.sections.metadata.BrandVoiceField';
export const AISkillSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AISkillSourceData';
export const AppSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData';
export const CrmObjectSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.CrmObjectSourceData';
export const WebsiteSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceData';
export const CrossTabVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabVisualization';
export const DatawellVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellVisualization';
export const FunnelVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.funnel.FunnelVisualization';
export const GaugeVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeVisualization';
export const PivotVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualization';
export const SankeyVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyVisualization';
export const SlicedVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedVisualization';
export const TableVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.table.TableVisualization';
export const WaterfallVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallVisualization';
export const XYVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYVisualization';
export const ActionCellTypename = 'com.hubspot.chatspot.message.schemas.table.ActionCell';
export const ImageCellTypename = 'com.hubspot.chatspot.message.schemas.table.ImageCell';
export const LinkCellTypename = 'com.hubspot.chatspot.message.schemas.table.LinkCell';
export const PlainTextCellTypename = 'com.hubspot.chatspot.message.schemas.table.PlainTextCell';
export const LinkTokenTypename = 'com.hubspot.chatspot.message.schemas.tokens.LinkToken';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const GridLayoutChangeMessageTypename = 'com.hubspot.content.ai.editor.models.rpc.GridLayoutChangeMessage';
export const LayoutChangeFailedMessageTypename = 'com.hubspot.content.ai.editor.models.rpc.LayoutChangeFailedMessage';
export const TextMessageTypename = 'com.hubspot.content.ai.editor.models.rpc.TextMessage';
export const ToolResultMessageTypename = 'com.hubspot.content.ai.editor.models.rpc.ToolResultMessage';
export const ToolUseMessageTypename = 'com.hubspot.content.ai.editor.models.rpc.ToolUseMessage';
export const ContainerTypename = 'com.hubspot.content.grid.layouts.models.components.Container';
export const GridContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.GridContainerLayout';
export const ModuleTypename = 'com.hubspot.content.grid.layouts.models.components.Module';
export const PegboardContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.PegboardContainerLayout';
export const StackContainerLayoutTypename = 'com.hubspot.content.grid.layouts.models.components.StackContainerLayout';
export const AutoPositionTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.AutoPosition';
export const AutoRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.AutoRowOrColumnSize';
export const FitContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.FitContentWidth';
export const FullContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.FullContentWidth';
export const ManualPositionTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.ManualPosition';
export const MaxContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MaxContentRowOrColumnSize';
export const MaxContentWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MaxContentWidth';
export const MinContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MinContentRowOrColumnSize';
export const MinMaxRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.MinMaxRowOrColumnSize';
export const SizedContentRowOrColumnSizeTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SizedContentRowOrColumnSize';
export const SizedWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SizedWidth';
export const SplitGapTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.SplitGap';
export const UnifiedGapTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.UnifiedGap';
export const BackgroundColorLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundColorLayer';
export const BackgroundGradientLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundGradientLayer';
export const BackgroundImageLayerTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.background.BackgroundImageLayer';
export const KeywordBorderWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.border.KeywordBorderWidth';
export const SizedBorderWidthTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.border.SizedBorderWidth';
export const BlurFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.BlurFilter';
export const BrightnessFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.BrightnessFilter';
export const ContrastFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.ContrastFilter';
export const DropShadowFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.DropShadowFilter';
export const FilterUrlTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.FilterUrl';
export const GrayscaleFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.GrayscaleFilter';
export const HueRotateFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.HueRotateFilter';
export const InvertFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.InvertFilter';
export const OpacityFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.OpacityFilter';
export const SaturateFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.SaturateFilter';
export const SepiaFilterTypename = 'com.hubspot.content.grid.layouts.models.styles.attributes.filter.SepiaFilter';
export const CitationModelResultTypename = 'com.hubspot.copilot.tools.results.CitationModelResult';

/**
 *  Represents a single frontend interaction to be executed.
 *  This defines a specific action the frontend should present to the user,
 *  such as displaying a shortened URL with copy functionality.
 */

/**
 *  Payload containing message text and frontend interactions to execute.
 *  This structure is serialized to JSON and placed in the Message agentPayload
 *  for the frontend to parse and execute.
 */

/**
 *  Result that triggers a frontend interactive tool call.
 *  When present in a ToolCallResponse, this will cause the backend to emit
 *  an INTERACTIVE_TOOL_CALL event to the frontend via ABLY.
 *  <p>
 *  This enables deterministic backend-to-frontend hooks without requiring
 *  an LLM intermediate step.
 */

export const OpaqueModelResultTypename = 'com.hubspot.copilot.tools.results.OpaqueModelResult';

/**
 *  Represents feedback provided for a copilot message citation.
 */

export const CrmCitationTypename = 'com.hubspot.copilot.tools.results.citations.CrmCitation';
export const DashworksCitationTypename = 'com.hubspot.copilot.tools.results.citations.DashworksCitation';
export const LegacyCitationTypename = 'com.hubspot.copilot.tools.results.citations.LegacyCitation';
export const WebPageCitationTypename = 'com.hubspot.copilot.tools.results.citations.WebPageCitation';
export let ComHubspotCopilotToolsResultsCitations;
(function (_ComHubspotCopilotToolsResultsCitations) {})(ComHubspotCopilotToolsResultsCitations || (ComHubspotCopilotToolsResultsCitations = {}));
export const generateLayoutRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'generateLayout',
  auth: 'app',
  fingerprint: 'J4vpBxxZ57wRlKsB9EXz2WwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateLayoutAsyncRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'generateLayoutAsync',
  auth: 'app',
  fingerprint: 'zjPei0FvAkiZx23cbh1OCmwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkTaskStatusRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'checkTaskStatus',
  auth: 'app',
  fingerprint: 'qkW31kN_6Yk3JnBslwkHoWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getToolsConfigRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getToolsConfig',
  auth: 'app',
  fingerprint: 'FFiwWz0xY2kHJxJawi4-mpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrGenerateImageRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getOrGenerateImage',
  auth: 'app',
  fingerprint: 'Gm-36camriUlY5DdmtJpiGwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrGenerateFormRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getOrGenerateForm',
  auth: 'app',
  fingerprint: 'aPbBw3x7d9KyryCKMk3ak2wI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateLayoutRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'updateLayout',
  auth: 'app',
  fingerprint: '7Cor9IQnScgRlKsB9EXz2WwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const editGridLayoutCodeRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'editGridLayoutCode',
  auth: 'app',
  fingerprint: 'WflNKIeQoAROediJoGeev2wI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReactCodeForGridLayoutRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getReactCodeForGridLayout',
  auth: 'app',
  fingerprint: 'xCDYlomGskOkEniMM-OJIWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateGridLayoutCodeRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'validateGridLayoutCode',
  auth: 'app',
  fingerprint: 'N_snnu6gJFkSXgaFewBlcmwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGridLayoutDocumentationRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getGridLayoutDocumentation',
  auth: 'app',
  fingerprint: 'XInWor2wHDykEniMM-OJIWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAvailableModulesRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getAvailableModules',
  auth: 'app',
  fingerprint: 'Dg-l3pVuR_OkEniMM-OJIWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const convertReactToGridLayoutRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'convertReactToGridLayout',
  auth: 'app',
  fingerprint: 'sPsBfEEqZixybYf_o6mbLWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const convertGridLayoutToReactCodeRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'convertGridLayoutToReactCode',
  auth: 'app',
  fingerprint: '52tzHEZmFwLP-9VZegUMG2wI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const writeGridLayoutToEditorContextRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'writeGridLayoutToEditorContext',
  auth: 'app',
  fingerprint: 'vkDbxLyZvtqSXvKukTVoL2wI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAIEditorContextRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'getAIEditorContext',
  auth: 'app',
  fingerprint: 'TJN7KjTW8Jkj_Ozv7uFIRmwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const aviatorGenerateLayoutSyncRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'aviatorGenerateLayoutSync',
  auth: 'app',
  fingerprint: 'wTzqIWbZWbrYsB0AfhO3wWwI9oRe8TyT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const aviatorGenerateLayoutStreamRpc = {
  serviceName: 'com.hubspot.content.ai.editor.rpc.LayoutGeneration',
  rpcName: 'aviatorGenerateLayoutStream',
  auth: 'app',
  fingerprint: 'wTzqIWbZWbrTosswzRJgDWwI9oRe8TyT',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};